import { render, staticRenderFns } from "./ViewSwitcherNew.vue?vue&type=template&id=4742a251&scoped=true&"
import script from "./ViewSwitcherNew.vue?vue&type=script&lang=js&"
export * from "./ViewSwitcherNew.vue?vue&type=script&lang=js&"
import style0 from "./ViewSwitcherNew.vue?vue&type=style&index=0&id=4742a251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742a251",
  null
  
)

export default component.exports